var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPensamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDDDF4",
    d: "M18 1C8.059 1 0 7.268 0 15c0 4.368 2.574 8.268 6.604 10.835C6.08 28.144 4.859 31.569 2 35c5.758-.96 9.439-3.761 11.716-6.416 1.376.262 2.805.416 4.284.416 9.941 0 18-6.268 18-14S27.941 1 18 1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#2A6797",
    cx: 18,
    cy: 15,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#2A6797",
    cx: 26,
    cy: 15,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#2A6797",
    cx: 10,
    cy: 15,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensamento);
export default __webpack_public_path__ + "static/media/pensamento.872708fd3a0deb42d9cd32086d616c88.svg";
export { ForwardRef as ReactComponent };